import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import ConsentScreen from ".";
import AddConsent from "./add-consent";
import UpdateConsent from "./edit-consent";

export default function ConsentLayout() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={ConsentScreen} />
      <Route exact path={`${path}/add`} component={AddConsent} />
      <Route exact path={`${path}/update/:informedConsentId`} component={UpdateConsent} />

      {/* Catch-all */}
      <Redirect to={path} />
    </Switch>
  );
}
